<template>
	<div class="iptFormBox">
		<el-form
			:model="accForm"
			ref="ruleForm"
			@validate="onValidate"
			:status-icon="true"
			label-width="100px"
			class="specialBox"
		>
			<el-form-item label="" id="ipt" :rules="rules.Phone" prop="Phone">
				<div class="iptBoxIn">
					<div><el-icon class="el-icon-mobile-phone icon"></el-icon></div>
					<el-input v-model="accForm.Phone" placeholder="手机号码" clearable>
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="" id="ipt" prop="ImgCode" :rules="rules.ImgCode">
				<div class="iptBoxIn">
					<div><el-icon class="el-icon-picture-outline icon"></el-icon></div>
					<el-input
						v-model="accForm.ImgCode"
						placeholder="图形验证码"
						ref="ipt"
					>
					</el-input>
					<div class="verificationCodeBox">
						<img
							:src="img"
							width="80px"
							height="40px"
							alt=""
							@click="changeCode"
							v-if="isshowImg"
						/>
						<!-- v-if="(isshowImg == renderComponent) == true" -->
					</div>
				</div>
			</el-form-item>
			<el-form-item
				label=""
				prop="VerificationCode"
				id="ipt"
				:rules="rules.VerificationCode"
			>
				<div class="iptBoxIn">
					<div><el-icon class="el-icon-message icon"></el-icon></div>
					<el-input v-model="accForm.VerificationCode" placeholder="短信验证码">
					</el-input>
					<div
						:class="[isShowcode == true ? 'codeText1' : 'codeText dsiableText']"
						@click="GetVerificationCode"
						v-if="!isshow"
					>
						获取验证码
					</div>
					<div
						v-if="isshow"
						:class="[
							isShowcode == true
								? 'codeText secondColor'
								: 'codeText secondColor '
						]"
					>
						{{ timeCount }}s后重新获取
					</div>
				</div>
				<div class="flexBox"></div>
			</el-form-item>

			<el-button
				:class="!validatePass ? 'signBtnTwo currenBtn' : 'signBtnTwo'"
				@click="handleLogin"
				type="primary"
				:disabled="!validatePass"
				>登录</el-button
			>
		</el-form>
	</div>
</template>

<script>
import {sendVerificationCode, getCode} from "@/api/user.js"
import verificationCode from "@/components/verificationCode/index.vue"
export default {
	components: {verificationCode},
	props: {},
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				this.isShowcode = false
				return callback(new Error("手机号不能为空"))
			} else {
				// const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
				const reg = /^[0-9]\d{10}$/
				console.log(reg.test(value))
				if (reg.test(value)) {
					this.isShowcode = true
					callback()
				} else {
					this.isShowcode = false
					return callback(new Error("请输入正确的手机号"))
				}
			}
		}
		return {
			// 表单是否整体通过验证
			validatePass: false,
			iscode: false, //限制验证码按钮禁用
			timer: null, //设置计时器,
			timeCount: 60,
			isshow: false,
			isShowcode: false, //限制验证码按钮禁用
			isshowImg: false,

			checked: true,

			img: "",
			accForm: {
				Phone: "",
				VerificationCode: "",
				ImgCodeGuid: "",
				ImgCode: "",
				Brower: "Browser"
			},
			iscode: "",
			rules: {
				Phone: [{validator: checkPhone, trigger: "change", required: true}],
				ImgCode: [
					{required: true, message: "请输入图形验证码", trigger: "change"}
				],
				VerificationCode: [
					{required: true, message: "请输入验证码", trigger: "change"}
				]
			}
		}
	},
	methods: {
		changeCode() {
			getCode().then((res) => {
				console.log(res, 111111)
				this.accForm.ImgCodeGuid = res.guid
				this.img = res.img
				this.isshowImg = true
			})
		},
		updateFormValidateStatus() {
			console.log(111)
			this.$nextTick(() => {
				let validateStateArr = []
				if (this.$refs.ruleForm) {
					validateStateArr = this.$refs.ruleForm.fields.map((item) => {
						if (item.validateState) {
							return item.validateState
						} else if (item.rules && item.rules.length > 0) {
							return "error"
						} else {
							return "success"
						}
					})
				}
				this.validatePass =
					validateStateArr.find((item) => item === "error") !== "error"

				console.log(!this.validatePass)
			})
		},
		onValidate(...args) {
			console.log("args", args)
			// if ((args[0] = "Phone")) {
			// 	console.log(1)
			// 	if (args[1] == false) {
			// 		this.isShowcode = false
			// 		console.log(this.isShowcode, 111)
			// 	} else if (args[1] == true) {
			// 		this.isShowcode = true
			// 		console.log(this.isShowcode, 2222)
			// 	}
			// }
			this.updateFormValidateStatus()
		},
		getCode(e) {
			this.iscode = e
			console.log(this.iscode)
			// console.log(e, 1111)
		},
		GetVerificationCode() {
			console.log(this.isShowcode)
			if (this.isShowcode == false) return
			sendVerificationCode({Phone: this.accForm.Phone}).then((res) => {
				this.isshow = true
				this.timer = setInterval(() => {
					if (this.timeCount > 0) {
						this.timeCount--
					} else {
						this.isshow = false
						clearInterval(this.timer)
						this.timer = null
						this.timeCount = 60
					}
				}, 1000)
				console.log(res)
			})
		},
		handleLogin() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.loading = true
					this.$store
						.dispatch("user/loginByCode", this.accForm)
						.then(() => {
							// this.$router.push({
							//   path: "/",
							// });
							this.$router.push({
								path: "/",
								query: this.otherQuery
							})
							this.loading = false
							this.$emit("closeDialog", false)
						})
						.catch(() => {
							this.loading = false
						})
				} else {
					console.log("error submit!!")
					return false
				}
			})
		}
	},
	mounted() {
		this.updateFormValidateStatus()
		this.changeCode()
	}
}
</script>

<style lang="scss" scope>
.iptFormBox {
	.el-input__validateIcon {
		display: none !important;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 20px;
	}
	.el-input--small .el-input__inner {
		border: none !important;
		background: #f2f2f2;

		width: 100%;
		height: 50px;
		// padding: 0 30px;
	}
	.signBtnTwo {
		// margin-top: 20px;
		padding: 14px 0;
		width: 100%;
		border: none;
		border-radius: 4px;
		color: #fff;
		background: #ffa78d;
	}

	.currenBtn {
		opacity: 0.6;
	}
	.el-button--primary {
		background-color: #ff4f1a;
		border-color: #ff4f1a;
		color: #fff;
		// padding: 10px 20px;
		font-size: 16px;
	}
	.el-input__inner {
		// background-color: #fff;
		color: #000;
	}
	.iptBoxIn {
		position: relative;
		display: flex;
		flex: 1;
		.dsiableText {
			cursor: not-allowed !important;
			color: #ffb099 !important;
		}
		.verificationCodeBox {
			position: absolute;
			// right: 10px;
			right: 0px;
			top: 5px;

			line-height: 50px;
		}
		.codeText {
			position: absolute;
			right: 10px;
			top: 0;
			line-height: 50px;
			cursor: pointer;
			color: #ffb099;

			// width: 100px;
		}
		.codeText1 {
			position: absolute;
			right: 10px;
			top: 0;
			line-height: 50px;
			cursor: pointer;
			color: #ff5724;

			// width: 100px;
		}
		.secondColor {
			color: #ffb099;
			cursor: not-allowed;
		}
		.icon {
			background: #cccccc;
			width: 50px !important;
			height: 50px;
			text-align: center;
			line-height: 50px;
			color: #fff;
			font-size: 30px;
		}
	}

	.el-form-item__content {
		margin-left: 0 !important;
	}
	.forgetPsd {
		display: flex;
		justify-content: space-between;
		vertical-align: middle;
		div {
			font-size: 14px;
			vertical-align: middle;
		}
	}
	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #ff4f1a;
		border-color: #ff4f1a;
	}
	.el-checkbox__input.is-checked + .el-checkbox__label {
		color: #ff4f1a;
	}
	.el-checkbox.is-bordered.is-checked {
		border-color: #ff4f1a;
	}
	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #ff4f1a;
	}
	.tips {
		margin-top: 10px;
		padding: 10px 0px 10px 10px;
		border-radius: 4px;
		font-size: 14px;
		color: #ff4f1a;
		background: #fdf5f2;
	}
}
</style>
